import Debug from "debug";

import { clientFetch } from "@flights/client-fetch";
import { ETTrackingRequest } from "@flights/types";
import { watchEt } from "@flights/et-universal";

const debug = Debug("utils:et");

const buffer: ETTrackingRequest[] = [];

export const ET_REPORT_INTERVAL = 500; // ms

const initETTracker = () => {
  setInterval(sendTrackingRequests, ET_REPORT_INTERVAL);
};

const sendTrackingRequests = () => {
  if (buffer.length <= 0) {
    return;
  }
  if (process.env.BUILD_TARGET === "server") {
    return;
  }
  if (window?.__GLOBAL_CONTEXT__?.shouldNotTrack) {
    return;
  }
  // Waiting for the order response for getting soylentEmail (only applicable to post booking screens)
  if (!!window?.__GLOBAL_CONTEXT__?.orderLoading) {
    return;
  }
  const flushedETRequests = buffer.splice(0); // also empties `buffer`

  clientFetch("/track/et", {
    method: "post",
    headers: {
      "Content-Type": "application/json",
      "X-Soylent-Email": window.__GLOBAL_CONTEXT__.soylentEmail ? window.__GLOBAL_CONTEXT__.soylentEmail : ""
    },
    body: JSON.stringify({
      requests: flushedETRequests
    }),
    credentials: "include",
    referrerPolicy: "strict-origin-when-cross-origin"
  })
    .then(() => {
      debug("Successfully reported", flushedETRequests);
    })
    .catch((error) => {
      buffer.unshift(...flushedETRequests);
      debug("Failed to report", flushedETRequests, "with error", error);
    });

  watchEt.log(flushedETRequests);
};

export { initETTracker };
